<template>
  <router-link
    :to="{ name: 'OrderDetails', query: { orderNumber: item.OrderNumber, orderSource: item.OrderSource, dealerCode: item.DealerCode, salesOrg: item.SalesOrg }}"
  >
    {{ item.OrderNumber }}
  </router-link>
</template>

<script>

  export default {
    props: {
      item: Object
    }
  }

</script>